// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { addSubscriptionCustom, deleteSubscriptionCustom, fetchSubscriptionCustom, updateSubscriptionCustom } from "./SubscriptionCustomAPI";


// const initialState = {
//   data: [],
//   loading: false,
//   pagination: {
//     current_page: 1,
//     last_page: 1,
//     total: 0,
//   },
//   error: null,
// };

// export const fetchSubscriptionCustomAsync = createAsyncThunk(
//   "subscriptionCustom/fetch",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await fetchSubscriptionCustom();
//       const resp = response.data;
//       // console.log("resp", resp)
//       return resp;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// export const addSubscriptionCustomAsync = createAsyncThunk(
//   "subscriptionCustom/add",
//   async (newSubscription, { rejectWithValue }) => {
//     try {
//       const response = await addSubscriptionCustom(newSubscription);
//       return response;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// export const updateSubscriptionCustomAsync = createAsyncThunk(
//   "subscriptionCustom/update",
//   async ({ id, updateSubscriptiondata }, { rejectWithValue }) => {
//     try {
//       const response = await updateSubscriptionCustom(id, updateSubscriptiondata);
//       return response;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// export const deleteSubscriptionCustomAsync = createAsyncThunk(
//   "subscriptionCustom/delete",
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await deleteSubscriptionCustom(id);
//       return response;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// const subscriptionSlice = createSlice({
//   name: "subscription",
//   initialState,
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       // Fetch cases
//       .addCase(fetchSubscriptionCustomAsync.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchSubscriptionCustomAsync.fulfilled, (state, action) => {
//         state.loading = false;
//         state.data = action.payload;
//         state.error = null;
//       })
//       .addCase(fetchSubscriptionCustomAsync.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
//       // Add cases
//       .addCase(addSubscriptionCustomAsync.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(addSubscriptionCustomAsync.fulfilled, (state, action) => {
//         state.loading = false;
//         state.data = [...state.data, action.payload];
//         state.error = null;
//       })
//       .addCase(addSubscriptionCustomAsync.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
//       // Update cases
//       .addCase(updateSubscriptionCustomAsync.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(updateSubscriptionCustomAsync.fulfilled, (state, action) => {
//         state.loading = false;
//         const updatedPlan = action.payload;
//         state.data = state.data.map((plan) =>
//           plan.uuid === updatedPlan.uuid ? updatedPlan : plan
//         );
//         state.error = null;
//       })
//       .addCase(updateSubscriptionCustomAsync.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
//       // Delete cases
//       .addCase(deleteSubscriptionCustomAsync.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(deleteSubscriptionCustomAsync.fulfilled, (state, action) => {
//         state.loading = false;
//         state.data = state.data.filter(
//           (item) => item.uuid !== action.payload.id
//         );
//         state.error = null;
//       })
//       .addCase(deleteSubscriptionCustomAsync.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const selectSubscriptionCustom = (state) => state.subscriptionCustom.data;
// export const selectSubscriptionCustomLoading = (state) => state.subscriptionCustom.loading;
// export const selectSubscriptionCustomError = (state) => state.subscriptionCustom.error;
// export const selectPagination = (state) => state.subscriptionCustom.pagination;

// export default subscriptionSlice.reducer;


import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import {
  addSubscriptionCustom,
  deleteSubscriptionCustom,
  fetchSubscriptionCustom,
  updateSubscriptionCustom,
} from "./SubscriptionCustomAPI"

const initialState = {
  data: [],
  loading: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    total: 0,
  },
  error: null,
}

export const fetchSubscriptionCustomAsync = createAsyncThunk(
  "subscriptionCustom/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchSubscriptionCustom()
      const resp = response.data
      return resp
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

export const addSubscriptionCustomAsync = createAsyncThunk(
  "subscriptionCustom/add",
  async (newSubscription, { rejectWithValue }) => {
    try {
      const response = await addSubscriptionCustom(newSubscription)
      return response
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

export const updateSubscriptionCustomAsync = createAsyncThunk(
  "subscriptionCustom/update",
  async ({ id, updateSubscriptiondata }, { rejectWithValue }) => {
    try {
      const response = await updateSubscriptionCustom(id, updateSubscriptiondata)
      return response
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

export const deleteSubscriptionCustomAsync = createAsyncThunk(
  "subscriptionCustom/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await deleteSubscriptionCustom(id)
      return response
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

const subscriptionSlice = createSlice({
  name: "subscriptionCustom", // Changed slice name to subscriptionCustom for clarity
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch cases
      .addCase(fetchSubscriptionCustomAsync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchSubscriptionCustomAsync.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
        state.error = null
      })
      .addCase(fetchSubscriptionCustomAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Add cases
      .addCase(addSubscriptionCustomAsync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(addSubscriptionCustomAsync.fulfilled, (state, action) => {
        state.loading = false
        state.data = [...state.data, action.payload]
        state.error = null
      })
      .addCase(addSubscriptionCustomAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Update cases
      .addCase(updateSubscriptionCustomAsync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateSubscriptionCustomAsync.fulfilled, (state, action) => {
        state.loading = false
        const updatedPlan = action.payload
        state.data = state.data.map((plan) => (plan.uuid === updatedPlan.uuid ? updatedPlan : plan))
        state.error = null
      })
      .addCase(updateSubscriptionCustomAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Delete cases
      .addCase(deleteSubscriptionCustomAsync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(deleteSubscriptionCustomAsync.fulfilled, (state, action) => {
        state.loading = false
        state.data = state.data.filter((item) => item.uuid !== action.payload.id)
        state.error = null
      })
      .addCase(deleteSubscriptionCustomAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const selectSubscriptionCustom = (state) => state.subscriptionCustom.data
export const selectSubscriptionCustomLoading = (state) => state.subscriptionCustom.loading
export const selectSubscriptionCustomError = (state) => state.subscriptionCustom.error
export const selectPagination = (state) => state.subscriptionCustom.pagination
export default subscriptionSlice.reducer
